import { useEffect, useState } from 'react';

/**
 * Returns `false` until `durationMs` has elapsed after mount, then `true`.
 * A non-positive duration resolves to `true` immediately. The timer restarts
 * whenever `durationMs` changes.
 */
export const useTimeElapsed = (durationMs: number): boolean => {
  const [elapsed, setElapsed] = useState(durationMs <= 0);

  useEffect(() => {
    if (durationMs <= 0) {
      setElapsed(true);
      return;
    }
    setElapsed(false);
    const timeoutId = window.setTimeout(() => setElapsed(true), durationMs);
    return () => window.clearTimeout(timeoutId);
  }, [durationMs]);

  return elapsed;
};
